import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';
var Check = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return (<g id={'guts'}>
            <path d='M6.30005 11.2L10.7 15.5L18.1 8.5' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>);
};
export default createSvg(Check, 'check');
